import SendIcon from '@mui/icons-material/Send'; // Using Send icon as a temporary substitute for Telegram
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL } from './shareUtils';

export const TelegramButton = ({ url, title, text, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();
  const shareText = encodeURIComponent(text ? `${text} ${shareUrl}` : shareUrl);

  const handleShare = () => {
    const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(
      shareUrl
    )}&text=${shareText}`;
    window.open(telegramUrl, '_blank');
  };

  return (
    <ShareButtonBase
      icon={<SendIcon />}
      label={intl.formatMessage({ id: 'ShareActions.telegram', defaultMessage: 'Telegram' })}
      url={shareUrl}
      onClick={handleShare}
      title={title}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      text={text}
      {...rest}
    />
  );
};

TelegramButton.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

TelegramButton.defaultProps = {
  url: '',
  title: 'Check this out',
  text: '',
};
